<template>
  <div class="footer">
    <div v-if="lineColor == 'blackNull'">
      <hr class="line-black">
    </div>
    <div v-else-if="lineColor == 'black'">
      <div class="setting-wrap">
        <div class="setting-contain" @click="editProfile">
          <fa-icon class="setting-icon" icon="fa fa-gear"/>
          <p>Edit Profile</p>
        </div>
      </div>
      <hr class="line-black">
    </div>
    <div v-else-if="lineColor == 'whiteExt'">
      <dialog id="debug-dialog" class="dialog">
        <form method="dialog">
          <span class="close-icon" @click="closeDialog"><fa-icon icon="fa fa-close" /></span>
          <p class="dialog-header">Troubleshooting details</p>
          <hr>
          <div class="dialog-content">
            <p class="error-topic">ERROR:</p>
            <p class="error-content">{{ displayError }}</p>
          </div>
        </form>
      </dialog>
      <div class="extra-icon">
        <fa-icon icon="fa fa-ellipsis-h" @click="debugDialog"/>
      </div>
      <hr class="line-white">
    </div>
    <div v-else>
      <hr class="line-white">
    </div>
    <div class="footer-contain">
      <div v-if="(lineColor == 'white')">
        <div class="text-white">
          <p><span class="text-blue">NFC SMART BUSINESS CARD</span> | Developed by Silicon Craft Technology PLC</p>
        </div>
      </div>
      <div v-else-if="(lineColor == 'whiteExt')">
        <div class="text-white">
          <p><span class="text-blue">NFC SMART BUSINESS CARD</span> | Developed by Silicon Craft Technology PLC</p>
        </div>
      </div>
      <div v-else>
        <div class="text-black">
          <p><span class="text-blue">NFC SMART BUSINESS CARD</span> | Developed by Silicon Craft Technology PLC</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from '@/store/user/actions';
import auths from '../store/auth/auths';

export default {
  name: 'FooterSIC',
  props: {
    lineColor: String
  },
  data() {
    return {
      displayError: '',
    }
  },
  methods: {
    editProfile() {
      this.$emitter.emit('editProfile');
    },
    debugDialog() {
      let dialog = document.getElementById("debug-dialog");
      if (dialog.open) {
        dialog.close();
      } else {
        dialog.show();
      }

      if(this.displayError == '')

      if(auths.authError != "")
      {
        this.displayError = auths.authError;
      }
      else if(actions.actionErrorMessage != "")
      {
        this.displayError += actions.actionErrorMessage;
        this.displayError += "\n";
      }
      else if(actions.actionError != "")
      {
        this.displayError += actions.actionError;
        this.displayError += "\n";
      }
      else
      {
        this.displayError = "NONE";
      }
    },
    closeDialog() {
      let dialog = document.getElementById("debug-dialog");
      dialog.close();
    },
  }
}
</script>

<style>
.footer {
  margin: auto;
  position: absolute;
  padding: 0;
  bottom: 0;
  left: 50%;
  width: 95%;
  text-align: center;
  overflow: hidden;
  transform: translate(-50%, 0%);
}
.line-black {
  width: 100%;
  border: 1px solid black;
}
.line-white {
  width: 100%;
  border: 1px solid white;
}
.footer-contain {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5em;
  padding-top: 0.7em; 
  padding-bottom: 0.6em;
}
.footer-img {
  float: left;
}
.text-black {
  color: black;
  font-size: 0.5rem;
}
.text-white {
  color: white;
  font-size: 0.5rem;
}
.text-blue {
  color: #3cd2ef;
}
p {
  margin: 0;
}
.setting-wrap {
  margin-top: 1rem;
  height: 1rem;
  margin-bottom: 0.5rem;
}
.setting-contain {
  float: right;
  color: #13c8ec;
  display: flex;
  margin-right: 1rem;
  font-size: 2.5vw;
}
.setting-icon {
  margin-right: 0.52vw;
}
.extra-icon {
  color: white;
  font-size: 1.2rem;
  text-align: right;
  right: 3vw;
}
.dialog-header {
  font-size: 1.2rem;
  text-align: center;
  padding: 0.5rem;
  padding-top: 1.5rem;
  font-weight: bold;
}
.dialog {
  width: 80%;
  position: relative;
  box-shadow: 4px 4px 5px #818181;
}
.dialog::backdrop {
  display: none;
}
.dialog-content {
  display: flex;
  padding: 0.2rem;
}
.close-icon {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  font-size: 23px;
  color: silver;
  cursor: pointer;
}
.error-topic{
  font-size: 0.8rem;
  font-weight: bold;
  padding-right: 1rem;
}
.error-content {
  font-size: 0.8rem;
  text-align: left;
  white-space: pre;
  text-wrap: wrap;
}
@media screen and (min-width: 660px) {
  .text-black {
    font-size: 0.7rem;
  }
  .text-white {
    font-size: 0.7rem;
  }
  .setting-contain {
    font-size: 1rem;
  }
  .footer-contain{
    margin-bottom: 0.2em;
    padding-top: 0.4em; 
  }
}
</style>